import React from 'react';
import I18N from '@leverege/i18n';
import { GlobalState, UI } from '@leverege/ui-redux';
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.actions.CollapseAction');
export default function CollapseAction(molten) {
  return {
    id: 'molten.dataViewers.collapseAction',
    matches: [{
      use: 'actionBar'
    }, {
      use: 'bottomRightActionBar'
    }],
    handles: ({
      clientProps
    }) => {
      const {
        settings,
        expanded,
        isMobile
      } = clientProps || {};
      return expanded && !isMobile && settings?.allowExpandedView;
    },
    layout: {
      sort: 'zzzzz'
    },
    appearance: cxt => {
      const icon = tIcon('icon', 'fa-solid fa-arrow-down-left-and-arrow-up-right-to-center');
      return {
        icon,
        name: t('minimize')
      };
    },
    perform: context => {
      GlobalState.dispatch(UI.set('expanded', null));
      GlobalState.dispatch(UI.set('expandedPathname', null));
    }
  };
}